// Privana-authored Safety presentation; tenant content is never a catalogue entry.
export default {
  "copy": {
    "accident": "Accident",
    "nearMiss": "Près de miss",
    "propertyDamage": "Dommages matériels",
    "memberComplaint": "Plainte des membres",
    "safeguardingConcern": "Préoccupation de la sécurité",
    "securityIncident": "Incidence sur la sécurité",
    "vehicleIncident": "Accident du véhicule",
    "environmentalIncident": "Incidence environnementale",
    "other": "Autre",
    "low": "Faible",
    "medium": "Moyen",
    "high": "Élevé",
    "critical": "Critique",
    "open": "Ouvrir",
    "investigating": "Enquêter",
    "awaitingAction": "Attendre l ' action",
    "closed": "Fermé",
    "member": "Membre",
    "staff": "Personnel",
    "contractor": "Entrepreneur",
    "visitor": "Visiteur",
    "guest": "Invité",
    "inProgress": "En cours",
    "completed": "Terminé",
    "cancelled": "Annulé",
    "photo": "Photo",
    "document": "Document",
    "witnessStatement": "Déclaration du témoin",
    "medical": "Services médicaux",
    "clear": "Effacer",
    "searching": "Recherche…",
    "noMatchesFound": "Pas de correspondance trouvée.",
    "occurredTimeIn12HourFormat": "Temps accumulé en format 12 heures",
    "affectedPerson": "Personne touchée",
    "remove": "Retirer",
    "personType": "Type de personne",
    "affectedMember": "Membre touché",
    "searchMemberNameEmailOrNumber": "Nom du membre de recherche, courriel ou numéro",
    "affectedStaffMember": "Fonctionnaire touché",
    "searchStaffNameOrEmail": "Nom du personnel de recherche ou courriel",
    "name": "Nom",
    "nameIfKnown": "Nom si connu",
    "roleInIncident": "Rôle des incidents",
    "affectedPersonBystanderDriver": "Personne touchée, spectateur, chauffeur...",
    "treatmentGiven": "Traitement donné",
    "firstAidNoneAmbulance": "Premiers secours, non, ambulance...",
    "injuryNotes": "Notes relatives aux blessures",
    "injuryDetailsOrAffectedPersonNotes": "Injure details or affected-person notes",
    "additionalNotes": "Notes supplémentaires",
    "sentToHospital": "Envoyé à l'hôpital",
    "addAShortTitleForTheIncident": "Ajouter un titre court pour l'incident.",
    "addWhenTheIncidentHappened": "Ajoute quand l'incident est arrivé.",
    "unableToSaveIncident": "Incapable de Enregistrer l'incident.",
    "basicDetails": "Détails de base",
    "incidentType": "Type d'incident",
    "severity": "Gravité",
    "status": "Statut",
    "title": "Titre",
    "eGSlipNearPoolSteps": "p.ex. Slip près des étapes de la piscine",
    "occurredDateTime": "Date/heure d ' essai",
    "location": "Lieu",
    "poolDeckKitchenCarPark": "Piscine, cuisine, parking...",
    "areaDepartment": "Zone/département",
    "leisureFBGrounds": "Loisirs, FtenantB, Terrains...",
    "description": "Description",
    "affectedPersonS": "Personne(s) touché(s)",
    "addAffectedPerson": "Ajouter la personne touchée",
    "immediateAction": "Action immédiate",
    "firstAidAreaMadeSafeManagerNotified": "Premiers soins, zone sécurisée, gérant notifié...",
    "investigation": "Enquête",
    "investigationNotes": "Notes d ' enquête",
    "rootCause": "Cause racine",
    "correctiveActionSummary": "Résumé de l ' action corrective",
    "cancel": "Annuler",
    "saving": "Enregistrement…",
    "saveIncident": "Éventilation",
    "addWitness": "Témoin",
    "searchMember": "Membre de la recherche",
    "searchStaff": "Personnel de recherche",
    "injuryDescriptionNotes": "Injure description / notes",
    "witnessType": "Type de témoin",
    "phone": "Téléphone",
    "email": "E-mail",
    "statement": "État",
    "actionTitle": "Titre d ' action",
    "searchAssignee": "Attribut de recherche",
    "actionDescription": "Description de l'action",
    "save": "Enregistrer",
    "chooseAFileToUpload": "Choisissez un fichier à télécharger.",
    "unableToUploadAttachment": "Impossible de télécharger la pièce jointe.",
    "uploadAttachment": "Chargement de l ' attache",
    "uploading": "Chargement...",
    "upload": "Chargement",
    "unableToLoadIncident": "Impossible de charger l'incident.",
    "unableToOpenAttachment": "Impossible d'ouvrir l'attachement.",
    "unableToCloseIncident": "Incapable de fermer l'incident.",
    "loadingIncident": "Chargement de l'incident...",
    "backToIncidentLog": "Retour au journal d'incident",
    "edit": "Modifier",
    "closeIncident": "Étrangement",
    "noDescriptionAddedYet": "Pas encore de description.",
    "locationLabel": "Lieu:",
    "area": "Domaine :",
    "affectedPersonLabel": "Personne touchée :",
    "add": "Ajouter",
    "noNotesAdded": "Pas de notes ajoutées.",
    "noAffectedPeopleAddedYet": "Aucune personne affectée n'a encore ajouté.",
    "witnesses": "Témoins",
    "noStatementAddedYet": "Aucune déclaration n'a encore été ajoutée.",
    "noWitnessesAddedYet": "Aucun témoin n'a été ajouté.",
    "followUpActions": "Mesures de suivi",
    "noDescription": "Pas de description.",
    "due": "Dû :",
    "noDate": "Pas de date",
    "markComplete": "Marque complète",
    "noFollowUpActionsYet": "Pas encore d'actions de suivi.",
    "attachments": "Attachements",
    "previewView": "Vue/Vue",
    "download": "Télécharger",
    "linkedAttachment": "Fixation liée",
    "noAttachmentsUploadedYet": "Pas encore de pièces jointes.",
    "immediateActionLabel": "Mesures immédiates :",
    "investigationNotesLabel": "Notes d ' enquête :",
    "rootCauseLabel": "Cause de la racine:",
    "correctiveAction": "Action corrective :",
    "auditHistory": "Historique de la vérification",
    "readOnlyAuditEntry": "Entrée en audit en lecture seule",
    "noAuditEntriesYet": "Pas encore d'entrées de vérification.",
    "closureNotesCorrectiveActionSummary": "Notes de clôture / sommaire des mesures correctives",
    "optionalNotesOrCorrectiveActionSummary": "Notes facultatives ou sommaire des mesures correctives",
    "closing": "Fermer...",
    "unableToLoadIncidents": "Incapable de charger des incidents.",
    "editIncident": "Modifier l ' incident",
    "newIncident": "Nouvel incident",
    "openIncidents": "Incidents ouverts",
    "closedThisMonth": "Fermé ce mois-ci",
    "incidentLog": "Journal sur les incidents",
    "newIncidentLabel": "Nouvel incident",
    "searchIncidents": "Des incidents de recherche...",
    "allStatuses": "Tous les statuts",
    "allTypes": "Tous les types",
    "allSeverities": "Toutes les disparités",
    "loadingIncidents": "Chargement des incidents...",
    "incidentNumber": "Numéro d ' incident",
    "date": "Date",
    "type": "Type",
    "actions": "Actions",
    "view": "Afficher",
    "noIncidentsFound": "Aucun incident",
    "select": "Sélectionnez...",
    "search": "Cherche...",
    "firstAid": "Premiers secours",
    "fireMarshal": "Maréchal du feu",
    "foodHygiene": "Hygiène alimentaire",
    "safeguarding": "Protection de la sécurité",
    "poolPlant": "Plante de piscine",
    "healthSafety": "Santé et sécurité",
    "manualHandling": "Manipulation manuelle",
    "groundsMaintenance": "Entretien des sols",
    "pesticideApplication": "Application du pesticide",
    "machinery": "Machines",
    "insurance": "Assurance",
    "methodStatement": "Énoncé de méthode",
    "riskAssessment": "Évaluation des risques",
    "custom": "Personnalisé",
    "active": "Actif",
    "expiringSoon": "Expirant bientôt",
    "expired": "Expiré",
    "missingExpiry": "Expiration manquante",
    "archived": "Archivé",
    "certificate": "Certificat",
    "addACertificationOrDocumentName": "Ajouter une certification ou un nom de document.",
    "uploadsMustBe25MBOrSmaller": "Les charges doivent être de 25 Mo ou plus petites.",
    "chooseAStaffMember": "Choisissez un membre du personnel.",
    "chooseOrCreateAContractor": "Choisissez ou créez un entrepreneur.",
    "addAHolderName": "Ajouter un nom de porte.",
    "unableToSaveCertification": "Incapable d'enregistrer la certification.",
    "editCertification": "Modifier la certification",
    "addCertification": "Ajouter la certification",
    "holder": "Porteur",
    "holderType": "Type de support",
    "staffMember": "Membre du personnel",
    "searchStaffLabel": "Le personnel de recherche...",
    "searchContractors": "Cherchez des entrepreneurs...",
    "createContractor": "Créer un entrepreneur",
    "companyNameIfNotListed": "Nom de la société s ' il n ' est pas indiqué",
    "holderName": "Nom du titulaire",
    "nameOrOrganisation": "Nom ou organisation",
    "certificationDetails": "Détails de la certification",
    "certificationName": "Nom de la certification",
    "eGEmergencyFirstAidAtWork": "e.g. secours d'urgence au travail",
    "issuingBody": "L ' organe délivrant l ' autorité",
    "trainingProviderOrAuthority": "Fournisseur ou autorité de formation",
    "certificateNumber": "Numéro de certificat",
    "issueDate": "Date de publication",
    "expiryDate": "Date d ' expiration",
    "notes": "Notes",
    "documents": "Documents",
    "viewDownload": "Voir / Télécharger",
    "attachmentType": "Type d ' appendice",
    "certificateUpload": "Transfert de certificat",
    "saveChanges": "Enregistrer les modifications",
    "certification": "Certification",
    "issuingBodyLabel": "L ' organe délivrant l ' autorité",
    "expiryDateLabel": "Date d ' expiration",
    "attachment": "Pièce jointe",
    "noFile": "Pas de fichier",
    "archive": "Archiver",
    "unableToLoadCertifications": "Impossible de charger les certifications.",
    "unableToArchiveCertification": "Incapable de la certification d'archive.",
    "totalCertifications": "Total des certifications",
    "expiringIn30Days": "Expiration en 30 jours",
    "missingExpiryLabel": "Expiration manquante",
    "contractorDocuments": "Documents contractuels",
    "certificationRegister": "Registre de certification",
    "addCertificationLabel": "Ajouter la certification",
    "staffCertifications": "Certifications du personnel",
    "contractorDocumentsLabel": "Documents contractuels",
    "documentLibrary": "Bibliothèque de documents",
    "searchHolderCertificationIssuingBody": "Titulaire de recherche, certification, organisme émetteur...",
    "allHolders": "Tous les détenteurs",
    "loadingCertifications": "Chargement des certifications...",
    "fileName": "Nom du fichier",
    "uploadDate": "Date de mise à jour",
    "previewDownload": "Aperçu / Télécharger",
    "noDocumentsUploadedYet": "Pas encore de documents téléchargés.",
    "noCertificationsAddedYet": "Aucune certification n'a encore été ajoutée",
    "archiveCertification": "Certification des archives",
    "archiving": "Archivage...",
    "fireSafety": "Sécurité incendie",
    "kitchen": "Cuisine",
    "clubhouse": "Club-house",
    "golfCourse": "Terrain de golf",
    "pool": "Piscine",
    "gym": "Salle de sport",
    "maintenance": "Maintenance",
    "housekeeping": "Entretien ménager",
    "security": "Sécurité",
    "general": "Généralités",
    "adHoc": "Ad hoc",
    "daily": "Quotidien",
    "weekly": "Semaine",
    "monthly": "mensuel",
    "quarterly": "Trimestre",
    "annually": "annuellement",
    "text": "Texte",
    "number": "Nombre",
    "signature": "Signature",
    "policy": "Politique",
    "procedure": "Procédure",
    "emergencyPlan": "Plan d ' urgence",
    "firePlan": "Plan d ' incendie",
    "templates": "Modèles",
    "checklistRuns": "Liste de contrôle Runs",
    "riskAssessments": "Évaluations des risques",
    "complianceCalendar": "Calendrier d ' application",
    "fireSafetyCheck": "Contrôle de la sécurité incendie",
    "firstAidKitCheck": "Vérification de la trousse de premiers soins",
    "kitchenOpeningCheck": "Vérificateur de cuisine",
    "poolSafetyCheck": "Vérification de la sécurité des piscines",
    "golfCourseMachineryCheck": "Machines de terrain de golf Check",
    "clubhouseWalkthrough": "Visite du club-house",
    "pass": "Passage",
    "failed": "Échec",
    "mixed": "Mixte",
    "incomplete": "Incomplet",
    "inProgressLabel": "En cours",
    "overdue": "En retard",
    "moreActions": "Plus d'actions",
    "selectedTeamMember": "Membre de l ' équipe",
    "searchByNameOrEmail": "Recherche par nom ou email",
    "noMatchingTeamMembers": "Pas de membres de l'équipe.",
    "scheduledChecklist": "Liste de contrôle prévue",
    "dueLabel": "Sommes dues",
    "runNow": "Cours maintenant.",
    "openRun": "Ouvrez-vous",
    "nothingHere": "Rien ici.",
    "viewMore": "Voir plus",
    "close": "Fermer",
    "unableToSaveTemplate": "Impossible de sauvegarder le modèle.",
    "editChecklistTemplate": "Modifier le modèle de la liste de contrôle",
    "createChecklistTemplate": "Créer un modèle de liste de contrôle",
    "templateName": "Nom du modèle",
    "category": "Catégorie",
    "areaDepartmentLabel": "Superficie / département",
    "frequency": "Fréquence",
    "defaultDueTime": "Temps dû par défaut",
    "hH": "HH",
    "mM": "MM",
    "activeTemplate": "Modèle actif",
    "recurringSchedule": "Calendrier récurrent",
    "startDate": "Date de début",
    "endDateOptional": "Date de fin facultative",
    "createRunXDaysBeforeDue": "Créer run X jours avant l'échéance",
    "defaultAssignees": "Attributs par défaut",
    "nextDuePreview": "Prochain avant-première:",
    "savedAfterTemplateIsCreatedOrUpdated": "Sauvegardé après la création ou la mise à jour du modèle.",
    "automaticSchedulingIsOff": "L'horaire automatique est éteint.",
    "checklistItems": "Éléments de la liste de contrôle",
    "addItem": "Ajouter",
    "itemLabel": "Étiquette",
    "helpText": "Aide au texte",
    "response": "Réponse",
    "required": "Obligatoire",
    "optional": "Facultatif",
    "photoOnFail": "Photo sur l'échec",
    "noPhotoRule": "Aucune règle de photo",
    "saveTemplate": "Sauvegarder le modèle",
    "unableToStartRun": "Impossible de commencer à courir.",
    "runChecklist": "Exécuter la liste de contrôle",
    "template": "Modèle",
    "selectTemplate": "Sélectionnez le modèle",
    "assignTo": "Assigner",
    "dueDateTime": "Date limite / heure",
    "starting": "À partir de...",
    "startRun": "Commencez par courir.",
    "noEvidenceUploadedYet": "Aucune preuve n'a encore été téléchargée.",
    "checklistRun": "Exécution de la liste de contrôle",
    "loadingChecklistRun": "Chargement de checklist run...",
    "assignedTo": "Affectée à:",
    "unassigned": "Non attribué",
    "fail": "Échouement",
    "pending": "En attente",
    "yes": "Oui",
    "no": "Non",
    "evidence": "Preuve",
    "completeRun": "Cours complet",
    "editRiskAssessment": "Modifier l ' évaluation des risques",
    "addRiskAssessment": "Ajouter l'évaluation des risques",
    "areaLabel": "Zone",
    "owner": "Propriétaire",
    "hazard": "Danger",
    "whoMayBeHarmed": "Qui peut être blessé",
    "controls": "Contrôles",
    "likelihood15": "Écart (1 à 5)",
    "severity15": "Sévérité (1-5)",
    "riskScore": "Rendement du risque",
    "reviewDate": "Date de la révision",
    "furtherActionRequired": "Autres mesures à prendre",
    "noDescriptionLabel": "Pas de description",
    "complete": "Complet",
    "noActionsAddedYet": "Aucune action n'a encore été ajoutée.",
    "dueDate": "Date d ' expiration",
    "addAction": "Ajouter une action",
    "uploadEvidence": "Chargement de preuves",
    "saveRiskAssessment": "Évaluation des risques",
    "uploadDocument": "Télécharger le document",
    "version": "Version",
    "file": "Fichier",
    "unableToLoadSafetyChecklists": "Impossible de charger les listes de contrôle de sécurité.",
    "dueThisWeek": "Dûre cette semaine",
    "dueThisMonth": "À payer ce mois-ci",
    "later": "Plus tard.",
    "archiveChecklistTemplate": "Modèle de la liste de vérification des archives",
    "archiveRiskAssessment": "Évaluation des risques d'archive",
    "archiveSafetyDocument": "Archive du document de sécurité",
    "unableToArchiveThisRecord": "Incapable d'archiver ce disque.",
    "activeTemplates": "Modèles actifs",
    "completedThisMonth": "Complété ce mois",
    "overdueChecks": "Vérifications en retard",
    "openRiskActions": "Mesures de risque ouvertes",
    "docsDueReview": "Documents à réviser",
    "safetyChecklists": "Listes de contrôle de sécurité",
    "createTemplate": "Créer un modèle",
    "loadingOperationalSafetySystem": "Chargement du système de sécurité opérationnel...",
    "searchTemplates": "Modèles de recherche...",
    "allCategories": "Toutes les catégories",
    "allFrequencies": "Toutes les fréquences",
    "activeOnly": "Activer uniquement",
    "allTemplates": "Tous les modèles",
    "archivedOnly": "Archivé seulement",
    "schedule": "Planning",
    "nextDue": "Prochaine échéance",
    "items": "Articles",
    "manual": "Manuel",
    "inactive": "Inactif",
    "runChecklistLabel": "Exécutez la liste",
    "noChecklistTemplatesYet": "Pas de modèles de liste de vérification pour l'instant",
    "searchRuns": "La recherche tourne...",
    "allResults": "Tous les résultats",
    "runNumber": "Numéro de piste",
    "assignedToLabel": "Assignés à",
    "result": "Résultat",
    "activeRisks": "Risques actifs",
    "highRisk": "Risque élevé",
    "reviewDue": "Examen attendu",
    "openActions": "Actions ouvertes",
    "searchRisks": "Risques de recherche...",
    "allScores": "Tous les scores",
    "highRiskOnly": "Risque élevé seulement",
    "riskNumber": "Numéro de risque",
    "searchDocuments": "Les documents de recherche...",
    "documentType": "Type de document",
    "preview": "Aperçu",
    "noSafetyDocumentsUploadedYet": "Aucun document de sécurité n'a encore été téléchargé.",
    "archiveRecord": "Archives",
    "everythingLooksHealthy": "Tout a l'air sain.",
    "aFewItemsNeedAttention": "Quelques points ont besoin d'attention.",
    "severalComplianceAreasNeedReview": "Plusieurs domaines de conformité doivent être examinés.",
    "immediateSafetyAttentionRequired": "Une attention immédiate à la sécurité est requise.",
    "unableToLoadSafetyDashboard": "Impossible de charger le tableau de bord de sécurité.",
    "dashboardCouldNotLoad": "Dashboard ne peut pas charger",
    "retry": "Réessayer",
    "safetyComplianceOverview": "Aperçu de la conformité de la sécurité",
    "criticalItems": "Éléments critiques",
    "needsAttention": "Besoin d ' attention",
    "refreshed": "Refrétée",
    "overallComplianceScore": "Note globale de conformité",
    "overdueChecklists": "Listes de contrôle en retard",
    "certsExpiring": "Certs expirant",
    "riskReviewsDue": "Examens des risques attendus",
    "policiesAndProcedures": "Politiques et procédures",
    "attentionRequired": "Attention requise",
    "noUrgentSafetyActions": "Aucune mesure de sécurité urgente",
    "recentActivity": "Activité récente",
    "noRecentSafetyActivityYet": "Pas encore d'activité de sécurité récente.",
    "incidentBreakdown": "Répartition des incidents",
    "noIncidentsRecorded": "Aucun incident enregistré.",
    "checklistHealth": "Liste de contrôle santé",
    "passRate": "Taux de réussite",
    "certificationHealth": "Certification de la santé",
    "valid": "Valide",
    "expiring": "Expiration",
    "riskDocumentHealth": "Risques et état des documents",
    "highRisks": "Risques élevés",
    "loadingDashboard": "Chargement Dashboard...",
    "loadingIncidentLog": "Chargement du journal d'incident...",
    "loadingCertificationsLabel": "Chargement des certifications...",
    "loadingChecklists": "Chargement Checklists...",
    "passFail": "Laissez-passer / échoue",
    "yesNo": "Oui / non",
    "criticalHighIncidents": "Incidents graves/hauts",
    "addFollowUpAction": "Ajouter des mesures de suivi",
    "noExpiryRecorded": "Aucune expiration enregistrée",
    "expiresToday": "Expire aujourd'hui",
    "healthy": "Santé",
    "atRisk": "Risque",
    "noDateSet": "Aucune date définie",
    "affectedPersonNumber": "Personne touchée {number}",
    "existingAffectedPersonNumber": "Personne touchée {number} (existante)",
    "removeAssignee": "Supprimer {name}",
    "assignee": "cessionnaire",
    "openCertificationActions": "Actions ouvertes pour {name}",
    "showingCalendarItems": "Affichage 3 de {count}",
    "calendarItemsOne": "Articles triés du plus récent au plus ancien : {count}.",
    "calendarItemsOther": "Articles triés du plus récent au plus ancien : {count}.",
    "dueOn": "{date}",
    "actionDescriptionDue": "{description} · dû {date}",
    "nextDueOn": "Prochain attendu {date}",
    "runDescription": "{template} · {category} · Échéance {date}",
    "assignedToNames": "Affecté à: {names}",
    "assignedCount": "Affectés : {count}",
    "openActionCount": "Ouverts : {count}",
    "automaticFrequency": "{frequency} · Auto",
    "starterExamples": "Commencez par des exemples club-friendly comme Fire Safety Check, First Aid Kit Check, Kitchen Opening Check, Pool Safety Check, Golf Course Machinery Check, Clubhouse Walkthrough.",
    "expiryOverdueOne": "Jours de retard : {count}",
    "expiryOverdueOther": "Jours de retard : {count}",
    "expiryRemainingOne": "Jours restants : {count}",
    "expiryRemainingOther": "Jours restants : {count}",
    "highCriticalCount": "Élevés/critiques : {count}",
    "dueInSevenDays": "Échéances dans 7 jours : {count}",
    "expiredCount": "Expirés : {count}",
    "riskActionCounts": "{high} haut · {actions} actions",
    "activity": "Activité de sécurité",
    "certificationExpires": "{name} · expire {date}",
    "moreCertifications": "+ {count} plus",
    "moveItemUp": "Déplacement de l'élément",
    "moveItemDown": "Déplacement de l'élément vers le bas",
    "dateFrom": "Date",
    "dateTo": "À ce jour",
    "cancelForm": "Annuler le formulaire.",
    "slipTripOrFall": "Balade, voyage ou automne",
    "cutOrLaceration": "Coupe ou lacération",
    "burn": "Brûlure",
    "allergicReaction": "Réaction allergique",
    "foodPoisoning": "Poison alimentaire",
    "equipmentRelatedInjury": "Injure liée à l ' équipement",
    "drowningNearDrowning": "Noyade/Near Drowning",
    "fire": "Feu",
    "flood": "Inondation",
    "gasLeak": "Fuseau de gaz",
    "powerOutage": "Énergie",
    "structuralDamage": "Dommages structurels",
    "chemicalSpill": "Déversement de produits chimiques",
    "securityBreach": "Violation de la sécurité",
    "theft": "Vol",
    "vandalism": "Vandalisme",
    "minorNoMedicalAttentionRequired": "Mineur - Pas d'attention médicale requise",
    "moderateFirstAidAdministered": "Modéré - Premiers secours administrés",
    "seriousMedicalAttentionRequired": "Sérieusement - L'attention médicale requise",
    "criticalEmergencyServicesCalled": "Services d'urgence appelés",
    "updateSafetyIncidentReport": "Rapport d ' incident sur la sécurité",
    "newSafetyIncidentReport": "Nouveau rapport sur les incidents de sécurité",
    "typeOfIncident": "Type d ' incident *",
    "severityLevel": "Niveau de gravité *",
    "locationOfIncident": "Lieu de l ' incident *",
    "eGPoolDeckMainDiningRoomTennisCourt1": "par exemple, Piscine, Salle à manger principale, Terrain de tennis 1",
    "detailedDescription": "Description détaillée *",
    "describeWhatHappenedHowItHappenedAndAnyContributingFactors": "Décrivez ce qui s'est passé, comment ça s'est passé, et tous les facteurs contributifs...",
    "injuredAffectedPerson": "Personne lésée/personne infectée",
    "fullNameOfInjuredPerson": "Nom complet de la personne lésée",
    "personTypeLegacy": "Type de personne",
    "clubMember": "Membre du Club",
    "memberGuest": "Membre invité",
    "staffMemberLegacy": "Membre du personnel *",
    "enterWitnessName": "Entrez le nom du témoin",
    "immediateActionTaken": "Mesures immédiates prises *",
    "describeTheImmediateResponseFirstAidGivenAreaSecuredEtc": "Décrivez la réponse immédiate, l'aide fournie, la zone sécurisée, etc.",
    "medicalAttentionRequired": "Soins médicaux requis",
    "emergencyServicesCalled": "Services d ' urgence",
    "reportedToAuthorities": "Signalés aux autorités",
    "photosTakenOfScene": "Photos prises de scène",
    "followUpActionRequired": "Mesures de suivi nécessaires",
    "updateReport": "Rapport de mise à jour",
    "submitIncidentReport": "Rapport d'incident",
    "cPRCardiopulmonaryResuscitation": "CPR (Rescitation cardiopulmonaire)",
    "firstAidLegacy": "Premier secours",
    "aEDAutomatedExternalDefibrillator": "AED (défibrillateur externe automatisé)",
    "lifeguardCertification": "Certification Lifeguard",
    "waterSafetyInstructor": "Instructeur de sécurité de l ' eau",
    "poolOperatorCertification": "Certification de l'opérateur de piscine",
    "foodSafetyServSafe": "Sécurité alimentaire/ServSafe",
    "foodHandlerCertificate": "Certificat de manutention alimentaire",
    "allergenAwareness": "Sensibilisation aux allergènes",
    "fireSafetyTraining": "Formation sur la sécurité incendie",
    "fireExtinguisherTraining": "Formation des extincteurs",
    "emergencyResponseTraining": "Formation aux interventions d ' urgence",
    "workplaceSafetyOSHA": "Sécurité des lieux de travail (OSHA)",
    "hazardousMaterialsHandling": "Traitement des matières dangereuses",
    "chemicalSafetyTraining": "Formation à la sécurité chimique",
    "electricalSafety": "Sécurité électrique",
    "forkliftOperation": "Chariot élévateur",
    "defensiveDriving": "Conduite défensive",
    "securityTraining": "Formation à la sécurité",
    "incidentCommandSystemICS": "Système de commandement des incidents (SICS)",
    "bloodbornePathogensTraining": "Formation des agents pathogènes d'origine sanguine",
    "confinedSpaceEntry": "Entrée dans l ' espace",
    "fallProtection": "Protection contre les chutes",
    "personalProtectiveEquipmentPPE": "Équipement de protection personnel (PPE)",
    "riskAssessmentLegacy": "Évaluation des risques",
    "emergencyActionPlanTraining": "Formation au Plan d ' action d ' urgence",
    "evacuationProcedures": "Procédures d'évacuation",
    "childProtectionSafeguarding": "Protection de l ' enfant/protection",
    "mentalHealthFirstAid": "Premiers soins de santé mentale",
    "wildernessFirstAid": "D ' urgence",
    "localFireDepartment": "Service local des incendies",
    "localHealthDepartment": "Département de la santé locale",
    "stateCertificationBoard": "Organisme public de certification",
    "professionalAssociation": "Association professionnelle",
    "trainingCompany": "Société de formation",
    "updateStaffCertification": "Mise à jour de la certification du personnel",
    "addStaffCertification": "Ajouter la certification du personnel",
    "enterStaffMemberName": "Entrez le nom de membre du personnel",
    "certificationType": "Type de certification *",
    "selectCertificationType": "Sélectionnez le type de certification",
    "issuingOrganization": "Organisation émettrice *",
    "selectIssuingOrganization": "Sélectionnez l ' organisation émettrice",
    "issueDateLegacy": "Date de publication *",
    "expiryDateLegacy": "Date d ' expiration *",
    "certificateDocument": "Document de certificat",
    "clickToUploadCertificateOrDragAndDrop": "Cliquez pour télécharger le certificat ou glisser-déposer",
    "pDFJPGPNGUpTo10MB": "PDF , JPG, PNG jusqu'à 10Mo",
    "certificateUploaded": "✓ Certificat téléchargé: {file}",
    "updateCertification": "Mise à jour de la certification",
    "staffMemberTitle": "Fonctionnaire",
    "highCriticalOne": "Élevés/critiques : {count}",
    "highCriticalOther": "Élevés/critiques : {count}",
    "dueSevenOne": "Échéances dans 7 jours : {count}",
    "dueSevenOther": "Échéances dans 7 jours : {count}",
    "expiredOne": "Expirés : {count}",
    "expiredOther": "Expirés : {count}",
    "openActionOne": "Ouverts : {count}",
    "openActionOther": "Ouverts : {count}",
    "assignedOne": "Affectés : {count}",
    "assignedOther": "Affectés : {count}",
    "riskActionOneOne": "{high} haut · {actions} actions",
    "riskActionOneOther": "{high} haut · {actions} actions",
    "riskActionOtherOne": "{high} haut · {actions} actions",
    "riskActionOtherOther": "{high} haut · {actions} actions",
    "affectedPeopleHelp": "Ajoutez chaque membre, membre du personnel, invité, visiteur, entrepreneur ou autre personne touchée par l'incident.",
    "incidentDescriptionPlaceholder": "Qu'est-ce qui s'est passé ?",
    "attachmentUploadHelp": "Les images, les PDF, les documents Word, les fichiers texte et CSV fichiers jusqu'à 25MB sont pris en charge.",
    "closeIncidentConfirmation": "Fermez cet incident? Vous pouvez toujours voir le dossier et l'historique des vérifications.",
    "incidentFormHelp": "Capturez les éléments essentiels maintenant; les notes d'enquête et le suivi peuvent croître au fil du temps.",
    "incidentRegisterHelp": "Un carnet d'accidents de club sécurisé pour les incidents, les manquements, les actions de suivi et l'historique des vérifications.",
    "incidentEmptyHelp": "Essayez de nettoyer les filtres, ou créez le premier incident lorsque quelque chose a besoin d'enregistrement.",
    "certificationFormHelp": "Garder les qualifications du personnel et les documents de conformité des entrepreneurs dans un registre sécurisé.",
    "renewalNotesPlaceholder": "Des notes de renouvellement utiles, des restrictions ou des vérifications de preuve.",
    "certificateUploadHelp": "Accepté: images, PDFs, documents Word, texte et CSV fichiers jusqu'à 25MB. Les fichiers sont stockés en privé et ouverts avec des liens signés.",
    "certificationRegisterHelp": "Suivre les premiers soins, les pompiers, l'hygiène alimentaire, la sauvegarde, le DBS, l'assurance entrepreneure, le RAMS et d'autres documents de conformité.",
    "archiveCertificationConfirmation": "Archiver cette certification? Elle sera cachée des vues de conformité actives mais conservée pour l'historique des vérifications.",
    "templateFormHelp": "Construire un contrôle de sécurité de club répétable avec les champs de réponse pratiques et les règles de preuve.",
    "recurringReminderHelp": "Le personnel affecté recevra un courriel et une notification de Privana 24 heures avant chaque course prévue.",
    "adHocScheduleHelp": "Les modèles spéciaux ne sont exécutés que manuellement. Choisissez Daily, Weekly, Monthly, Quarterly ou Annually pour permettre l'horaire automatique.",
    "startRunHelp": "Sélectionnez un modèle, les assignes et la date d'échéance pour cette vérification.",
    "riskFormHelp": "Capturer le danger, contrôler et revoir le rythme en langage clair.",
    "documentStorageHelp": "Stockage de documents privés avec aperçu et liens de téléchargement signés.",
    "checklistRegisterHelp": "Modèles, vérifications en direct, examens des risques, documents et dates de conformité à venir pour votre club.",
    "archiveRecordHelp": "Cela le cachera des vues actives, mais la conservera pour l'historique de l'audit.",
    "dashboardUpToDateHelp": "Vos incidents, certifications, vérifications, risques et documents sont à jour.",
    "dbs": "DBS",
    "coshh": "COSHH",
    "rams": "RAMS",
    "cctv": "CCTV",
    "teamMember": "Membre de l ' équipe",
    "memberNumber": "Membre # {number}"
  },
  "enums": {
    "accident": "Accident",
    "near_miss": "Près de miss",
    "property_damage": "Dommages matériels",
    "member_complaint": "Plainte des membres",
    "safeguarding_concern": "Préoccupation de la sécurité",
    "security_incident": "Incidence sur la sécurité",
    "vehicle_incident": "Accident du véhicule",
    "environmental_incident": "Incidence environnementale",
    "other": "Autre",
    "low": "Faible",
    "medium": "Moyen",
    "high": "Élevé",
    "critical": "Critique",
    "open": "Ouvrir",
    "investigating": "Enquêter",
    "awaiting_action": "Attendre l ' action",
    "closed": "Fermé",
    "member": "Membre",
    "staff": "Personnel",
    "contractor": "Entrepreneur",
    "visitor": "Visiteur",
    "guest": "Invité",
    "in_progress": "En cours",
    "completed": "Terminé",
    "cancelled": "Annulé",
    "photo": "Photo",
    "document": "Document",
    "witness_statement": "Déclaration du témoin",
    "medical": "Services médicaux",
    "cctv": "CCTV",
    "first_aid": "Premiers secours",
    "fire_marshal": "Maréchal du feu",
    "food_hygiene": "Hygiène alimentaire",
    "safeguarding": "Protection de la sécurité",
    "dbs": "DBS",
    "pool_plant": "Plante de piscine",
    "health_safety": "Santé et sécurité",
    "coshh": "COSHH",
    "manual_handling": "Manipulation manuelle",
    "grounds_maintenance": "Entretien des sols",
    "pesticide_application": "Application du pesticide",
    "machinery": "Machines",
    "insurance": "Assurance",
    "rams": "RAMS",
    "method_statement": "Énoncé de méthode",
    "risk_assessment": "Évaluation des risques",
    "custom": "Personnalisé",
    "valid": "Actif",
    "expiring_soon": "Expirant bientôt",
    "expired": "Expiré",
    "missing_expiry": "Expiration manquante",
    "archived": "Archivé",
    "certificate": "Certificat",
    "fire_safety": "Sécurité incendie",
    "kitchen": "Cuisine",
    "clubhouse": "Club-house",
    "golf_course": "Terrain de golf",
    "pool": "Piscine",
    "gym": "Salle de sport",
    "maintenance": "Maintenance",
    "housekeeping": "Entretien ménager",
    "security": "Sécurité",
    "general": "Généralités",
    "ad_hoc": "Ad hoc",
    "daily": "Quotidien",
    "weekly": "Semaine",
    "monthly": "mensuel",
    "quarterly": "Trimestre",
    "annually": "annuellement",
    "text": "Texte",
    "number": "Nombre",
    "signature": "Signature",
    "policy": "Politique",
    "procedure": "Procédure",
    "emergency_plan": "Plan d ' urgence",
    "fire_plan": "Plan d ' incendie",
    "templates": "Modèles",
    "runs": "Liste de contrôle Runs",
    "risks": "Évaluations des risques",
    "documents": "Documents",
    "calendar": "Calendrier d ' application",
    "draft": "projet de projet",
    "review_due": "Examen attendu",
    "scheduled_checklist": "Liste de contrôle prévue",
    "checklist_run": "exécution de la liste de contrôle",
    "checklist": "Liste de contrôle",
    "incident": "Incident",
    "risk": "Risques",
    "safety_document": "Document de sécurité",
    "evidence": "éléments de preuve",
    "inactive": "inactif",
    "blocked": "bloqués"
  },
  "audit": {
    "incident_created": "incident créé",
    "incident_updated": "incident actualisé",
    "incident_closed": "incident clos",
    "certification_created": "certification créée",
    "certification_updated": "mise à jour",
    "certification_archived": "certification archivée",
    "person_added": "personne ajoutée",
    "person_updated": "mise à jour",
    "person_removed": "personne enlevée",
    "witness_added": "témoin ajouté",
    "witness_updated": "mise à jour du témoin",
    "witness_removed": "témoin enlevé",
    "action_added": "action ajoutée",
    "action_updated": "mise à jour",
    "action_cancelled": "action annulée",
    "attachment_added": "pièce jointe ajoutée",
    "attachment_uploaded": "pièces jointes téléchargées",
    "attachment_removed": "fixation enlevée",
    "created": "créé",
    "updated": "mise à jour",
    "archived": "Archivé",
    "cancelled": "annulé",
    "completed": "achevé",
    "item_added": "article ajouté",
    "item_updated": "Point mis à jour",
    "item_removed": "Point enlevé",
    "item_completed": "Point terminé",
    "schedule_recalculated": "tableau recalculé",
    "scheduled_run_created": "programmé run created"
  },
  "errors": {
    "unknown": "Impossible de remplir cette demande de sécurité. Veuillez réessayer.",
    "server_error": "Impossible de remplir cette demande de sécurité. Veuillez réessayer.",
    "validation_error": "Veuillez vérifier les champs, dates, scores et éléments de preuve requis avant de poursuivre.",
    "not_found": "Ce dossier ou fichier de sécurité n'est plus disponible.",
    "run_locked": "Cette série de listes de vérifications est en lecture seule. Les pistes complétées ou annulées ne peuvent pas être modifiées.",
    "invalid_upload": "Sélectionnez un fichier valide pour télécharger.",
    "file_too_large": "Les fichiers d'attestation doivent être de 25 Mo ou plus petits.",
    "unsupported_file_type": "Télécharger une image, PDF , document Word, fichier texte, ou CSV .",
    "upload_storage_unavailable": "Le stockage de pièces jointes de sécurité n'est pas disponible. S'il vous plaît contactez le support.",
    "unauthorized": "Connectez-vous pour accéder à Sécurité.",
    "forbidden": "Vous n'avez pas la permission d'effectuer cette action de sécurité.",
    "timeout": "S'il vous plaît essayez à nouveau.",
    "network_error": "Impossible de se connecter à Sécurité. Vérifiez votre connexion et essayez à nouveau.",
    "invalid_json": "La réponse de sécurité n'a pas pu être lue. Veuillez réessayer."
  },
  "generated": {
    "overdueChecklist": "Liste de contrôle en retard: {name}",
    "expiredCertification": "Certification expirée: {name}",
    "riskReviewDue": "Examen des risques attendus: {name}",
    "documentReviewDue": "Examen des documents attendus: {name}",
    "checklistDueSoon": "Liste de vérification à venir: {name}",
    "certificationExpiresSoon": "Certification expire bientôt: {name}",
    "incidentSeverity": "{severity} incident de gravité ouvert",
    "viewIncident": "Incidence",
    "reviewCertificate": "Certificat d ' examen",
    "reviewRisk": "Examen des risques",
    "reviewDocument": "Document d’examen",
    "openCalendar": "Calendrier ouvert",
    "openRun": "Ouvrez-vous",
    "incidentUpdated": "Incident mis à jour",
    "certificationUpdated": "Certification mise à jour",
    "safetyItemUpdated": "Point de sécurité mis à jour",
    "activity_incident_created_incident": "Incident Créé incident",
    "activity_incident_updated_incident": "Incident Actif mis à jour",
    "activity_incident_closed_incident": "Incident Fermé",
    "activity_certification_created_incident": "Certification Créé incident",
    "activity_certification_updated_incident": "Attestations",
    "activity_certification_archived_incident": "Certificat d'incident archivé",
    "activity_person_added_incident": "Personne Ajout d ' incident",
    "activity_person_updated_incident": "Personne à jour incident",
    "activity_person_removed_incident": "Personne en cas d ' incident",
    "activity_witness_added_incident": "Témoin ajouté",
    "activity_witness_updated_incident": "Témoin ayant mis à jour un incident",
    "activity_witness_removed_incident": "Cas d ' incident",
    "activity_action_added_incident": "Action ajouté incident",
    "activity_action_updated_incident": "Mesure de l ' incident",
    "activity_action_cancelled_incident": "Action Annulée",
    "activity_attachment_added_incident": "Incident ajouté",
    "activity_attachment_uploaded_incident": "Pièce jointe téléchargée",
    "activity_attachment_removed_incident": "Attachement Enlevé",
    "activity_created_incident": "Incident créé",
    "activity_updated_incident": "Actif mis à jour",
    "activity_archived_incident": "Archivé",
    "activity_cancelled_incident": "Incident annulé",
    "activity_completed_incident": "Incidence achevée",
    "activity_item_added_incident": "Point ajouté",
    "activity_item_updated_incident": "Point sur l ' incident",
    "activity_item_removed_incident": "Point Enlèvement d ' incident",
    "activity_item_completed_incident": "Article Complété incident",
    "activity_schedule_recalculated_incident": "Annexe Incident recalculé",
    "activity_scheduled_run_created_incident": "Cour programmée Incident créé",
    "activity_incident_created_certification": "Incident Créé une certification",
    "activity_incident_updated_certification": "Incident Certification mise à jour",
    "activity_incident_closed_certification": "Incident Certification fermée",
    "activity_certification_created_certification": "Certification Certification Création de certification",
    "activity_certification_updated_certification": "Certification Mise à jour",
    "activity_certification_archived_certification": "Certification Certification Archivée",
    "activity_person_added_certification": "Certification ajoutée à la personne",
    "activity_person_updated_certification": "Personne Mise à jour de la certification",
    "activity_person_removed_certification": "Personne Certification supprimée",
    "activity_witness_added_certification": "Attestation ajoutée par le témoin",
    "activity_witness_updated_certification": "Attestation mise à jour",
    "activity_witness_removed_certification": "Témoignage Suprême",
    "activity_action_added_certification": "Action ajouté certification",
    "activity_action_updated_certification": "Mise à jour de la certification",
    "activity_action_cancelled_certification": "Lutte contre la certification",
    "activity_attachment_added_certification": "Attachment Ajout d ' une certification",
    "activity_attachment_uploaded_certification": "Attachement Certification surchargée",
    "activity_attachment_removed_certification": "Attachement Certification supprimée",
    "activity_created_certification": "Certification créée",
    "activity_updated_certification": "Mise à jour de la certification",
    "activity_archived_certification": "Certification archivée",
    "activity_cancelled_certification": "Certification annulée",
    "activity_completed_certification": "Certification complète",
    "activity_item_added_certification": "Point d ' homologation",
    "activity_item_updated_certification": "Point Mise à jour de la certification",
    "activity_item_removed_certification": "Article Certification supprimée",
    "activity_item_completed_certification": "Article Certification complète",
    "activity_schedule_recalculated_certification": "Annexe Certification recalculée",
    "activity_scheduled_run_created_certification": "Cours programmé Certification Créée",
    "activity_incident_created_checklist_run": "Incident créé checklist run",
    "activity_incident_updated_checklist_run": "Incident Actualisé checklist run",
    "activity_incident_closed_checklist_run": "Incident Chiffre fermé",
    "activity_certification_created_checklist_run": "Certification Lancement de la liste de contrôle",
    "activity_certification_updated_checklist_run": "Certification Actualisé checklist run",
    "activity_certification_archived_checklist_run": "Certification Archived checklist run",
    "activity_person_added_checklist_run": "Personne a ajouté checklist run",
    "activity_person_updated_checklist_run": "Personne Actualisé checklist run",
    "activity_person_removed_checklist_run": "Personne Supprimer la liste de vérification",
    "activity_witness_added_checklist_run": "Témoin ajouté checklist run",
    "activity_witness_updated_checklist_run": "Witness Actual checklist run",
    "activity_witness_removed_checklist_run": "Témoin Cour de la liste de contrôle supprimée",
    "activity_action_added_checklist_run": "Action ajouté checklist run",
    "activity_action_updated_checklist_run": "Action Actualisé checklist run",
    "activity_action_cancelled_checklist_run": "Action annulé checklist run",
    "activity_attachment_added_checklist_run": "Attachment Ajouté checklist run",
    "activity_attachment_uploaded_checklist_run": "Saisie de la liste de contrôle téléchargée",
    "activity_attachment_removed_checklist_run": "Attachement Supprimer la liste de contrôle",
    "activity_created_checklist_run": "Lancement de la liste de contrôle",
    "activity_updated_checklist_run": "Actualisé checklist run",
    "activity_archived_checklist_run": "Archivé checklist run",
    "activity_cancelled_checklist_run": "Vérification annulée",
    "activity_completed_checklist_run": "Lancement de la liste de contrôle",
    "activity_item_added_checklist_run": "Objet ajouté checklist run",
    "activity_item_updated_checklist_run": "Point Actualisé checklist run",
    "activity_item_removed_checklist_run": "Point Effectif de la liste de contrôle supprimé",
    "activity_item_completed_checklist_run": "Point Cour de la liste de contrôle complétée",
    "activity_schedule_recalculated_checklist_run": "Liste de vérification recalculée",
    "activity_scheduled_run_created_checklist_run": "Course programmée Lancement de la liste de contrôle créée",
    "activity_incident_created_checklist_template": "Incident créé le modèle de liste de vérification",
    "activity_incident_updated_checklist_template": "Incident Correction du modèle de la liste de vérification",
    "activity_incident_closed_checklist_template": "Exemple de liste de vérification fermée",
    "activity_certification_created_checklist_template": "Certification Modèle de liste de contrôle créé",
    "activity_certification_updated_checklist_template": "Certification Mise à jour du modèle de liste de contrôle",
    "activity_certification_archived_checklist_template": "Certification Modèle de liste de contrôle archivé",
    "activity_person_added_checklist_template": "Personne a ajouté le modèle de la liste de vérification",
    "activity_person_updated_checklist_template": "Person Mise à jour du modèle de liste de vérification",
    "activity_person_removed_checklist_template": "Person Supprimer le modèle de liste de vérification",
    "activity_witness_added_checklist_template": "Le modèle de la liste de vérification des témoins",
    "activity_witness_updated_checklist_template": "Témoin Mise à jour de la liste de contrôle",
    "activity_witness_removed_checklist_template": "Témoin Modèle de liste de contrôle supprimé",
    "activity_action_added_checklist_template": "Action ajouté checklist template",
    "activity_action_updated_checklist_template": "Mise à jour de la liste de contrôle",
    "activity_action_cancelled_checklist_template": "Modèle de liste de vérification annulée",
    "activity_attachment_added_checklist_template": "Attachment Ajout du modèle de liste de vérification",
    "activity_attachment_uploaded_checklist_template": "Le modèle de liste de contrôle téléchargée",
    "activity_attachment_removed_checklist_template": "Attachement Supprimer le modèle de la liste de vérification",
    "activity_created_checklist_template": "Modèle de liste de vérification créée",
    "activity_updated_checklist_template": "Mise à jour du modèle de liste de vérification",
    "activity_archived_checklist_template": "Modèle de liste de contrôle archivé",
    "activity_cancelled_checklist_template": "Modèle de liste de vérification annulé",
    "activity_completed_checklist_template": "Modèle de liste de vérification complète",
    "activity_item_added_checklist_template": "Objet ajouté checklist template",
    "activity_item_updated_checklist_template": "Point Mise à jour de la liste de vérification",
    "activity_item_removed_checklist_template": "Point Modèle de liste de contrôle supprimé",
    "activity_item_completed_checklist_template": "Point Modèle de liste de vérification complète",
    "activity_schedule_recalculated_checklist_template": "Calendrier de la liste de vérification recalculée",
    "activity_scheduled_run_created_checklist_template": "Calendrier de la liste de vérification créée",
    "activity_incident_created_risk_assessment": "Incident Évaluation du risque créé",
    "activity_incident_updated_risk_assessment": "Incident Évaluation des risques actualisée",
    "activity_incident_closed_risk_assessment": "Incident Évaluation des risques fermés",
    "activity_certification_created_risk_assessment": "Certification Évaluation des risques",
    "activity_certification_updated_risk_assessment": "Certification Évaluation des risques actualisée",
    "activity_certification_archived_risk_assessment": "Certification Évaluation des risques archivés",
    "activity_person_added_risk_assessment": "Évaluation des risques par personne",
    "activity_person_updated_risk_assessment": "Personne Évaluation des risques mise à jour",
    "activity_person_removed_risk_assessment": "Personne Évaluation des risques supprimés",
    "activity_witness_added_risk_assessment": "Évaluation des risques ajoutée par le témoin",
    "activity_witness_updated_risk_assessment": "Témoin Évaluation des risques actualisée",
    "activity_witness_removed_risk_assessment": "Témoin Évaluation des risques supprimés",
    "activity_action_added_risk_assessment": "The action Ajout risk assessment",
    "activity_action_updated_risk_assessment": "Mesures à prendre",
    "activity_action_cancelled_risk_assessment": "Action Annulée évaluation des risques",
    "activity_attachment_added_risk_assessment": "Attachement Ajout d'une évaluation des risques",
    "activity_attachment_uploaded_risk_assessment": "Attachement Évaluation des risques téléchargés",
    "activity_attachment_removed_risk_assessment": "Attachement Évaluation des risques supprimés",
    "activity_created_risk_assessment": "Évaluation des risques créée",
    "activity_updated_risk_assessment": "Évaluation des risques actualisées",
    "activity_archived_risk_assessment": "Évaluation des risques archivée",
    "activity_cancelled_risk_assessment": "Évaluation des risques annulés",
    "activity_completed_risk_assessment": "Évaluation complète des risques",
    "activity_item_added_risk_assessment": "Évaluation des risques",
    "activity_item_updated_risk_assessment": "Point Évaluation des risques actualisées",
    "activity_item_removed_risk_assessment": "Point Évaluation des risques supprimés",
    "activity_item_completed_risk_assessment": "Point Évaluation complète des risques",
    "activity_schedule_recalculated_risk_assessment": "Annexe Évaluation des risques recalculés",
    "activity_scheduled_run_created_risk_assessment": "Cour programmée Évaluation des risques créés",
    "activity_incident_created_safety_document": "Incident Créé document de sécurité",
    "activity_incident_updated_safety_document": "Incident Document de sécurité mis à jour",
    "activity_incident_closed_safety_document": "Incident Document de sécurité fermé",
    "activity_certification_created_safety_document": "Certification Créé document de sécurité",
    "activity_certification_updated_safety_document": "Certification Document de sécurité mis à jour",
    "activity_certification_archived_safety_document": "Certification Document de sécurité archivé",
    "activity_person_added_safety_document": "Personne a ajouté le document de sécurité",
    "activity_person_updated_safety_document": "Document de sécurité mis à jour",
    "activity_person_removed_safety_document": "Personne Supprimer le document de sécurité",
    "activity_witness_added_safety_document": "Document de sécurité ajouté par le témoin",
    "activity_witness_updated_safety_document": "Témoin Document de sécurité actualisé",
    "activity_witness_removed_safety_document": "Témoin Document de sécurité supprimé",
    "activity_action_added_safety_document": "Action ajouté document de sécurité",
    "activity_action_updated_safety_document": "Mise à jour du document de sécurité",
    "activity_action_cancelled_safety_document": "Action Annulé document de sécurité",
    "activity_attachment_added_safety_document": "Document de sécurité ajouté",
    "activity_attachment_uploaded_safety_document": "Pièces jointes Document de sécurité surchargé",
    "activity_attachment_removed_safety_document": "Attachement Supprimer le document de sécurité",
    "activity_created_safety_document": "Créé document de sécurité",
    "activity_updated_safety_document": "Document de sécurité mis à jour",
    "activity_archived_safety_document": "Document de sécurité archivé",
    "activity_cancelled_safety_document": "Document de sécurité annulé",
    "activity_completed_safety_document": "Document de sécurité complet",
    "activity_item_added_safety_document": "Point Ajout du document de sécurité",
    "activity_item_updated_safety_document": "Point Document de sécurité mis à jour",
    "activity_item_removed_safety_document": "Point Supprimer le document de sécurité",
    "activity_item_completed_safety_document": "Article Document de sécurité complet",
    "activity_schedule_recalculated_safety_document": "Calendrier Document de sécurité recalculé",
    "activity_scheduled_run_created_safety_document": "Cour prévue Document de sécurité créé",
    "activity_incident_closed": "Incident fermé",
    "activity_incident_created": "Incident créé",
    "activity_certification_updated": "Certification mise à jour",
    "activity_checklist_completed": "Liste de vérification terminée",
    "activity_checklist_run_created": "Exécution de la liste de contrôle créée",
    "activity_risk_assessment_updated": "Évaluation des risques mise à jour",
    "activity_document_archived": "Document archivé",
    "activity_document_uploaded": "Document téléchargé"
  },
  "reminders": {
    "recipient": "Là-bas.",
    "subject": "Liste de vérification à venir: {name}",
    "hello": "Bonjour {name},",
    "checklist": "Liste de vérification: {name}",
    "due": "Sommes dues: {date}",
    "area": "Superficie/département: {area}",
    "category": "Catégorie: {category}",
    "instructions": "Cette liste de vérification est attendue prochainement. Veuillez la compléter dans le portail Privana et consulter le dossier de la liste de vérification pour plus de détails.",
    "openLink": "Ouvrir la liste de contrôle en Privana : {url}",
    "open": "Ouvrir la liste de contrôle en Privana",
    "logo": "logo Club",
    "dueSentence": "{name} est attendu {date} .",
    "title": "Liste de vérification attendue demain",
    "body": "{name} est attendu {date} . Ouvrez Privana pour l'achever."
  }
};
